export default __webpack_public_path__ + "static/media/credit-cards.88bcf9df.png";